import { render, staticRenderFns } from "./CertificateScholarship.vue?vue&type=template&id=257dba66"
import script from "./CertificateScholarship.vue?vue&type=script&lang=js"
export * from "./CertificateScholarship.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports